import React from "react"

function CpsiCharges(){
    return <React.Fragment>
        <iframe title="Charges" width="1400" height="800" src="https://app.powerbi.com/reportEmbed?reportId=ee599b50-8e16-4c97-ac91-8c78e9467231&autoAuth=true&ctid=49423d5d-8d49-4128-b53d-59537808f6ac" allowFullScreen={true}></iframe>
    </React.Fragment>
}

export{CpsiCharges}